export default __webpack_public_path__ + "static/media/magazine.52b331aa.jpg";